// extracted by mini-css-extract-plugin
export default {"form":"CollaboratorCreate_form__9mOFX"};